import { Component, OnInit } from '@angular/core';

import * as _ from 'lodash';
import { AttributesComponent } from './attributes.component';
import { AttributesStatisticCollectionNames } from 'src/shared/enums';
import { CalibrationSetTableFieldAttributesPopupComponent } from './attributes-popup/calibration-set-table-field-attributes-popup.component';
import { IAttributePopupEntityParams } from 'src/app/interfaces/attribute-popup-params.interface';

@Component({
    standalone: false,
    selector: 'calibration-set-table-field-attributes',
    templateUrl: './attributes.component.html',
    styleUrls: ['./attributes.component.scss']

})
export class CalibrationSetTableFieldAttributesComponent extends AttributesComponent implements OnInit {
    ngOnInit() {
        super.ngOnInit();
        this.entityName = AttributesStatisticCollectionNames.CALIBRATION_SET_TABLE_FIELDS_ATTRIBUTES_STATISTICS;
        this.popupComponent = CalibrationSetTableFieldAttributesPopupComponent;
    }

    getParameters(): IAttributePopupEntityParams {
        return {
            ParentId: this.calibrationSetId,
            ParentType: this.calibrationSetType,
            TableFieldId: this.tableFieldId,
            TableFieldOption: this.tableFieldOption,
        };
    }
}
